/*
 * Supercycle default rental term — always preselect the LONGEST available term.
 *
 * The rental-term picker renders client-side as clickable cards:
 * `div.supercycle-options__option`, each with a `.supercycle-options__option-title`
 * (e.g. "24 months"). It defaults to the shortest term and exposes no setting to
 * change that. A plain .click() on an option selects it (verified: switches the
 * price + selling plan), so on load we click the option with the highest month
 * count (24 on most products, 36 on the edits, etc.).
 *
 * Because Supercycle sets its own default (shortest) shortly AFTER the options
 * render, a single early click can be overridden — so we re-assert on DOM changes
 * and at a few intervals until the summary confirms the longest term is selected,
 * then stop.
 *
 * FAIL-SAFE: only ever clicks a real, rendered option; if none exist it does
 * nothing and the default stays. It can't break the price, plan, or add-to-cart.
 */
(function () {
  var OPTION = '.supercycle-options__option';
  var TITLE = '.supercycle-options__option-title';
  var SUMMARY = '.supercycle-summary-line__value';
  var settled = false;
  var lastClick = 0;

  function scan() {
    var best = null, most = -1;
    var opts = document.querySelectorAll(OPTION);
    for (var i = 0; i < opts.length; i++) {
      var titleEl = opts[i].querySelector(TITLE) || opts[i];
      var m = (titleEl.textContent || '').match(/(\d+)\s*months?/i);
      var n = m ? parseInt(m[1], 10) : -1;
      if (n > most) { most = n; best = opts[i]; }
    }
    return { best: best, most: most };
  }

  // The order summary echoes the chosen term ("… 24 months"); use it as the
  // source of truth for whether the longest term is actually selected.
  function longestSelected(most) {
    if (most < 0) return false;
    var re = new RegExp('\\b' + most + '\\s*months?\\b', 'i');
    var lines = document.querySelectorAll(SUMMARY);
    for (var i = 0; i < lines.length; i++) {
      if (re.test(lines[i].textContent || '')) return true;
    }
    return false;
  }

  function attempt() {
    if (settled) return;
    var s = scan();
    if (!s.best) return; // options not rendered yet
    if (longestSelected(s.most)) { settled = true; return; }
    var now = Date.now();
    if (now - lastClick < 250) return; // debounce rapid mutation re-fires
    lastClick = now;
    s.best.click();
  }

  attempt();
  var obs = new MutationObserver(function () {
    attempt();
    if (settled) obs.disconnect();
  });
  obs.observe(document.documentElement, { childList: true, subtree: true });
  [400, 900, 1600, 2600, 4000].forEach(function (t) { setTimeout(attempt, t); });
  // Stop watching after 8s regardless, so we never observe indefinitely.
  setTimeout(function () { obs.disconnect(); }, 8000);
})();
